import { GraphQLFormattedError } from "graphql";

export const actionTypes = {
  REQUEST_FAILURE: "REQUEST_FAILURE",
  SET_GLOBAL_LOADING: "SET_GLOBAL_LOADING",
  SET_GLOBAL_ALERT: "SET_GLOBAL_ALERT",
  RESET_GLOBAL_ALERT: "RESET_GLOBAL_ALERT",
};

const setGlobalLoading = (isLoading: boolean) => ({
  type: actionTypes.SET_GLOBAL_LOADING,
  payload: isLoading,
});

const requestFailure = (error: ReadonlyArray<GraphQLFormattedError> | null) => ({
  type: actionTypes.REQUEST_FAILURE,
  payload: error,
});

const setGlobalAlert = (payload: { severity: "error" | "warning" | "info" | "success" | null,
  message: string,
   customMessage?: JSX.Element | null,
   customIcon?: string,
   alertType?: string }) => ({
  type: actionTypes.SET_GLOBAL_ALERT,
  payload,
});

const resetGlobalAlert = () => ({
  type: actionTypes.RESET_GLOBAL_ALERT,
});

export default {
  setGlobalLoading,
  requestFailure,
  setGlobalAlert,
  resetGlobalAlert,
};
